import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { IDevelopmentProject } from '../../../../shared/interfaces/development-project.interface';
import { Router } from '@angular/router';
import { MarketingProjectsService } from '../../../../shared/services/marketing.projects.service';
import { Button } from '../../../../shared/components/button/button';
import { IMarketingProject } from '../../../../shared/interfaces/marketing-project.interface';

@Component({
  selector: 'app-projects',
  imports: [CommonModule, Button],
  templateUrl: './projects.html',
  styleUrl: './projects.scss'
})
export class Projects {

  projects$!: Observable<IMarketingProject[]>;

  constructor(private router: Router, private mktProjectsService: MarketingProjectsService) { }

  ngOnInit(): void {
    this.projects$ = this.mktProjectsService.getProjects();
  }

  navigateTo(path: string) {
    this.router.navigate(['marketing', path]);
  }
}
